import React from 'react';
import { Box, Typography } from '@mui/material';
import { getCountryCode, getFlagImageUrl } from '../utils/countryFlags';

export default function CountryFlagLabel({ country, size = 22 }) {
  const code = getCountryCode(country);
  const flagUrl = getFlagImageUrl(country);
  const label = country || '-';

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.8,
        minWidth: 0,
        verticalAlign: 'middle',
      }}
    >
      {flagUrl ? (
        <Box
          component="img"
          src={flagUrl}
          alt={code}
          loading="lazy"
          sx={{
            width: size,
            height: Math.round(size * 0.68),
            objectFit: 'cover',
            borderRadius: '3px',
            border: '1px solid rgba(0,0,0,0.12)',
            boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
            flex: '0 0 auto',
          }}
        />
      ) : null}
      <Typography component="span" noWrap sx={{ font: 'inherit' }}>
        {label}
      </Typography>
    </Box>
  );
}
